import React, { useState } from 'react';
import { Globe, ExternalLink, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const DiplomaticCarousel = () => {
  const { language } = useLanguage();
  const [selectedLetter, setSelectedLetter] = useState(null);

  // Traductions manuelles et forcées selon la langue
  const getLetters = () => {
    if (language === 'fr') {
      return [
        {
          country: 'Guinée-Bissau',
          authority: 'Ministère de la Santé Publique',
          flag: '🇬🇼',
          date: '22 Mai 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png',
          color: 'emerald'
        },
        {
          country: 'Nigéria - Abuja',
          authority: 'Ministère Fédéral de la Santé',
          flag: '🇳🇬',
          date: '11 Juin 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png',
          color: 'green'
        },
        {
          country: 'Cameroun - Ouest',
          authority: 'Conseil Régional (4 CHRu)',
          flag: '🇨🇲',
          date: '2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Cameroun - Est',
          authority: 'Conseil Régional',
          flag: '🇨🇲',
          date: '23 Mai 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Cameroun - Littoral',
          authority: 'Conseil Régional (34+4 Hôpitaux)',
          flag: '🇨🇲',
          date: '06 Fév 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Cameroun - SCH',
          authority: 'Centre Scientifique de Santé',
          flag: '🇨🇲',
          date: '04 Juin 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png',
          color: 'sky'
        },
      ];
    }
    
    if (language === 'it') {
      return [
        {
          country: 'Guinea-Bissau',
          authority: 'Ministero della Salute Pubblica',
          flag: '🇬🇼',
          date: '22 Maggio 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png',
          color: 'emerald'
        },
        {
          country: 'Nigeria - Abuja',
          authority: 'Ministero Federale della Salute',
          flag: '🇳🇬',
          date: '11 Giugno 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png',
          color: 'green'
        },
        {
          country: 'Camerun - Ovest',
          authority: 'Consiglio Regionale (4 CHRu)',
          flag: '🇨🇲',
          date: '2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camerun - Est',
          authority: 'Consiglio Regionale',
          flag: '🇨🇲',
          date: '23 Maggio 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camerun - Litorale',
          authority: 'Consiglio Regionale (34+4 Ospedali)',
          flag: '🇨🇲',
          date: '06 Feb 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camerun - SCH',
          authority: 'Centro Scientifico di Salute',
          flag: '🇨🇲',
          date: '04 Giugno 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png',
          color: 'sky'
        },
      ];
    }
    
    if (language === 'pt') {
      return [
        {
          country: 'Guiné-Bissau',
          authority: 'Ministério da Saúde Pública',
          flag: '🇬🇼',
          date: '22 Maio 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png',
          color: 'emerald'
        },
        {
          country: 'Nigéria - Abuja',
          authority: 'Ministério Federal da Saúde',
          flag: '🇳🇬',
          date: '11 Junho 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png',
          color: 'green'
        },
        {
          country: 'Camarões - Oeste',
          authority: 'Conselho Regional (4 CHRu)',
          flag: '🇨🇲',
          date: '2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camarões - Leste',
          authority: 'Conselho Regional',
          flag: '🇨🇲',
          date: '23 Maio 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camarões - Litoral',
          authority: 'Conselho Regional (34+4 Hospitais)',
          flag: '🇨🇲',
          date: '06 Fev 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png',
          color: 'emerald'
        },
        {
          country: 'Camarões - SCH',
          authority: 'Centro Científico de Saúde',
          flag: '🇨🇲',
          date: '04 Junho 2024',
          url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png',
          color: 'sky'
        },
      ];
    }
    
    // Default: English
    return [
      {
        country: 'Guinea-Bissau',
        authority: 'Ministry of Public Health',
        flag: '🇬🇼',
        date: '22 May 2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png',
        color: 'emerald'
      },
      {
        country: 'Nigeria - Abuja',
        authority: 'Federal Ministry of Health',
        flag: '🇳🇬',
        date: '11 June 2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png',
        color: 'green'
      },
      {
        country: 'Cameroon - West',
        authority: 'Regional Council (4 CHRu)',
        flag: '🇨🇲',
        date: '2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png',
        color: 'emerald'
      },
      {
        country: 'Cameroon - East',
        authority: 'Regional Council',
        flag: '🇨🇲',
        date: '23 May 2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png',
        color: 'emerald'
      },
      {
        country: 'Cameroon - Littoral',
        authority: 'Regional Council (34+4 Hospitals)',
        flag: '🇨🇲',
        date: '06 Feb 2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png',
        color: 'emerald'
      },
      {
        country: 'Cameroon - SCH',
        authority: 'Scientific Center for Health',
        flag: '🇨🇲',
        date: '04 June 2024',
        url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png',
        color: 'sky'
      },
    ];
  };

  // Russian letters
  const getRussianLetters = () => [
    { country: 'Гвинея-Бисау', authority: 'Министерство общественного здравоохранения', flag: '🇬🇼', date: '22 мая 2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png', color: 'emerald' },
    { country: 'Нигерия - Абуджа', authority: 'Федеральное министерство здравоохранения', flag: '🇳🇬', date: '11 июня 2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png', color: 'green' },
    { country: 'Камерун - Запад', authority: 'Региональный совет (4 CHRu)', flag: '🇨🇲', date: '2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png', color: 'emerald' },
    { country: 'Камерун - Восток', authority: 'Региональный совет', flag: '🇨🇲', date: '23 мая 2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png', color: 'emerald' },
    { country: 'Камерун - Литораль', authority: 'Региональный совет (34+4 больницы)', flag: '🇨🇲', date: '06 февраля 2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png', color: 'emerald' },
    { country: 'Камерун - SCH', authority: 'Научный центр здравоохранения', flag: '🇨🇲', date: '04 июня 2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png', color: 'sky' },
  ];

  // Chinese letters
  const getChineseLetters = () => [
    { country: '几内亚比绍', authority: '公共卫生部', flag: '🇬🇼', date: '2024年5月22日', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/vr885rcm_int%C3%A9r%C3%AAt%20Guin%C3%A9e%20Bissau.png', color: 'emerald' },
    { country: '尼日利亚 - 阿布贾', authority: '联邦卫生部', flag: '🇳🇬', date: '2024年6月11日', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/2cbjvzy6_int%C3%A9r%C3%AAt%20Abuja%20Nig%C3%A9ria.png', color: 'green' },
    { country: '喀麦隆 - 西部', authority: '地区委员会（4个CHRu）', flag: '🇨🇲', date: '2024', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/x4wwo05m_int%C3%A9r%C3%AAt%20Oest%20Cameroun.png', color: 'emerald' },
    { country: '喀麦隆 - 东部', authority: '地区委员会', flag: '🇨🇲', date: '2024年5月23日', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/quackqyj_int%C3%A9r%C3%AAt%20Est%20Cameroun.png', color: 'emerald' },
    { country: '喀麦隆 - 滨海', authority: '地区委员会（34+4家医院）', flag: '🇨🇲', date: '2024年2月6日', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/rv9pev1w_int%C3%A9r%C3%AAt%20Littoral%20Cameroun.png', color: 'emerald' },
    { country: '喀麦隆 - SCH', authority: '卫生科学中心', flag: '🇨🇲', date: '2024年6月4日', url: 'https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/eoktf9y4_int%C3%A9r%C3%AAt%20sch%20Cameroun.png', color: 'sky' },
  ];

  const letters = language === 'ru' ? getRussianLetters() : language === 'zh' ? getChineseLetters() : getLetters();

  return (
    <>
      <div className="py-16 bg-slate-50" data-testid="diplomatic-carousel">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-4">
              <p className="text-sm font-semibold text-emerald-600 uppercase tracking-wider flex items-center gap-2">
                <Globe className="w-4 h-4" />
                {language === 'fr' && 'Confiance Internationale'}
                {language === 'en' && 'International Trust'}
                {language === 'pt' && 'Confiança Internacional'}
                {language === 'it' && 'Fiducia Internazionale'}
                {language === 'ru' && 'Международное Доверие'}
                {language === 'zh' && '国际信任'}
              </p>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" style={{fontFamily: 'Playfair Display, serif'}}>
              {language === 'fr' && 'Ils nous font confiance'}
              {language === 'en' && 'They Trust Us'}
              {language === 'pt' && 'Eles Confiam em Nós'}
              {language === 'it' && 'Ci Accordano la Loro Fiducia'}
              {language === 'ru' && 'Нам доверяют'}
              {language === 'zh' && '他们信任我们'}
            </h2>
            <p className="text-base md:text-lg text-slate-600">
              {language === 'fr' && 'Manifestations d\'Intérêt Officielles de Gouvernements Africains'}
              {language === 'en' && 'Official Expressions of Interest from African Governments'}
              {language === 'pt' && 'Manifestações de Interesse Oficiais de Governos Africanos'}
              {language === 'it' && 'Espressioni di Interesse Ufficiali da Parte di Governi Africani'}
              {language === 'ru' && 'Официальные выражения интереса от африканских правительств'}
              {language === 'zh' && '非洲政府的官方意向表达'}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {letters.map((letter, i) => (
              <div 
                key={i}
                className="group cursor-pointer bg-white border-2 border-slate-200 rounded-2xl p-6 hover:border-emerald-500 hover:shadow-xl transition-all"
                onClick={() => setSelectedLetter(letter)}
                data-testid={`diplomatic-card-${i}`}
              >
                <div className="text-5xl mb-4">{letter.flag}</div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">
                  {letter.country}
                </h3>
                <p className="text-sm text-slate-600 mb-3 line-clamp-2">
                  {letter.authority}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-emerald-600">{letter.date}</span>
                  <ExternalLink className="w-4 h-4 text-slate-400 group-hover:text-emerald-600 transition-colors" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedLetter && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedLetter(null)}
          data-testid="letter-modal"
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            onClick={() => setSelectedLetter(null)}
            data-testid="close-letter-modal"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          <div className="max-w-4xl w-full">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 mb-4">
              <div className="flex items-center gap-4">
                <div className="text-4xl">{selectedLetter.flag}</div>
                <div>
                  <h3 className="text-2xl font-bold text-white">{selectedLetter.country}</h3>
                  <p className="text-slate-300">{selectedLetter.authority}</p>
                  <p className="text-sm text-emerald-400 font-semibold">{selectedLetter.date}</p>
                </div>
              </div>
            </div>
            <img 
              src={selectedLetter.url}
              alt={`Lettre ${selectedLetter.country}`} 
              className="w-full rounded-2xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
};
